import { Product, ProductImageType, ProductType } from '../../context/CartContext';

// SnapCharms Images - now in public/images/snapcharms/

// Standard Size Images
const standard_alien1 = '/images/snapcharms/standard_alien1.webp';
const standard_hog1 = '/images/snapcharms/standard_hog1.webp';
const standard_dog1 = '/images/snapcharms/standard_dog1.webp';
const standard_cat1 = '/images/snapcharms/standard_cat1.webp';
const standard_bunny1 = '/images/snapcharms/standard_bunny1.webp';
const standard_pumpkin1 = '/images/snapcharms/standard_pumpkin1.webp';
const standard_snowman1 = '/images/snapcharms/standard_snowman1.webp';
const standard_white_cat1 = '/images/snapcharms/standard_white_cat1.webp';
const standard_river_otter1 = '/images/snapcharms/standard_river_otter1.webp';
const standard_lil_stripe1 = '/images/snapcharms/standard_lil_stripe1.webp';
const standard_brown_cat1 = '/images/snapcharms/standard_brown_cat1.webp';

const standard_christmas_tree1 = '/images/snapcharms/standard_christmas_tree1.webp';
const standard_christmas_star1 = '/images/snapcharms/standard_christmas_star1.webp';

const standard_model_cat1 = '/images/snapcharms/standard_model_cat1.webp';
const standard_model_hog1 = '/images/snapcharms/standard_model_hog1.webp';
const standard_model_dog1 = '/images/snapcharms/standard_model_dog1.webp';
const standard_model_alien1 = '/images/snapcharms/standard_model_alien1.webp';
const standard_model_white_cat1 = '/images/snapcharms/standard_model_white_cat1.webp';
const standard_model_bunny1 = '/images/snapcharms/standard_model_bunny1.webp';
const standard_model_pumpkin1 = '/images/snapcharms/standard_model_pumpkin1.webp';
const standard_model_snowman1 = '/images/snapcharms/standard_model_snowman1.webp';
const standard_model_river_otter1 = '/images/snapcharms/standard_model_river_otter1.webp';
const standard_model_lil_stripe1 = '/images/snapcharms/standard_model_lil_stripe1.webp';
const standard_model_brown_cat1 = '/images/snapcharms/standard_model_brown_cat1.webp';

const standard_model_christmas_tree1 = '/images/snapcharms/standard_model_christmas_tree1.webp';
const standard_model_christmas_star1 = '/images/snapcharms/standard_model_christmas_star1.webp';

// Large Size Images
const large_alien1 = '/images/snapcharms/large_alien1.webp';
const large_hog1 = '/images/snapcharms/large_hog1.webp';
const large_dog1 = '/images/snapcharms/large_dog1.webp';
const large_cat1 = '/images/snapcharms/large_cat1.webp';
const large_bunny1 = '/images/snapcharms/large_bunny1.webp';
const large_pumpkin1 = '/images/snapcharms/large_pumpkin1.webp';
const large_snowman1 = '/images/snapcharms/large_snowman1.webp';
const large_white_cat1 = '/images/snapcharms/large_white_cat1.webp';
const large_river_otter1 = '/images/snapcharms/large_river_otter1.webp';
const large_lil_stripe1 = '/images/snapcharms/large_lil_stripe1.webp';
const large_brown_cat1 = '/images/snapcharms/large_brown_cat1.webp';

const large_model_alien1 = '/images/snapcharms/large_model_alien1.webp';
const large_model_hog1 = '/images/snapcharms/large_model_hog1.webp';
const large_model_dog1 = '/images/snapcharms/large_model_dog1.webp';
const large_model_cat1 = '/images/snapcharms/large_model_cat1.webp';
const large_model_bunny1 = '/images/snapcharms/large_model_bunny1.webp';
const large_model_pumpkin1 = '/images/snapcharms/large_model_pumpkin1.webp';
const large_model_snowman1 = '/images/snapcharms/large_model_snowman1.webp';
const large_model_river_otter1 = '/images/snapcharms/large_model_river_otter1.webp';
const large_model_lil_stripe1 = '/images/snapcharms/large_model_lil_stripe1.webp';
const large_model_brown_cat1 = '/images/snapcharms/large_model_brown_cat1.webp';
const large_model_white_cat1 = '/images/snapcharms/large_model_white_cat1.webp';

// Micro Size Images
const micro_alien1 = '/images/snapcharms/micro_alien1.webp';
const micro_hog1 = '/images/snapcharms/micro_hog1.webp';
const micro_dog1 = '/images/snapcharms/micro_dog1.webp';
const micro_cat1 = '/images/snapcharms/micro_cat1.webp';
const micro_bunny1 = '/images/snapcharms/micro_bunny1.webp';
const micro_pumpkin1 = '/images/snapcharms/micro_pumpkin1.webp';
const micro_snowman1 = '/images/snapcharms/micro_snowman1.webp';
const micro_white_cat1 = '/images/snapcharms/micro_white_cat1.webp';
const micro_river_otter1 = '/images/snapcharms/micro_river_otter1.webp';
const micro_lil_stripe1 = '/images/snapcharms/micro_lil_stripe1.webp';
const micro_brown_cat1 = '/images/snapcharms/micro_brown_cat1.webp';

const micro_model_alien1 = '/images/snapcharms/micro_model_alien1.webp';
const micro_model_hog1 = '/images/snapcharms/micro_model_hog1.webp';
const micro_model_dog1 = '/images/snapcharms/micro_model_dog1.webp';
const micro_model_cat1 = '/images/snapcharms/micro_model_cat1.webp';
const micro_model_bunny1 = '/images/snapcharms/micro_model_bunny1.webp';
const micro_model_pumpkin1 = '/images/snapcharms/micro_model_pumpkin1.webp';
const micro_model_snowman1 = '/images/snapcharms/micro_model_snowman1.webp';
const micro_model_river_otter1 = '/images/snapcharms/micro_model_river_otter1.webp';
const micro_model_lil_stripe1 = '/images/snapcharms/micro_model_lil_stripe1.webp';
const micro_model_brown_cat1 = '/images/snapcharms/micro_model_brown_cat1.webp';
const micro_model_white_cat1 = '/images/snapcharms/micro_model_white_cat1.webp';

const general_snap_charm_subtext = 'Can be worn as a pendant or snapped on your bag !  Comes with a keychain included !';

export const snapCharmsProducts: Product[] = [

  { 
    id: '2', 
    name: 'Hog SnapCharm', 
    price: 5, 
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_hog1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_hog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute pig necklace. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '202',
    name: 'Hog SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_hog1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_hog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute pig necklace micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '102',
    name: 'Hog SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_hog1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_hog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute pig necklace large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '9',
    name: 'River Otter SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_river_otter1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_river_otter1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable river otter snap charm, complete with a tail ! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '109',
    name: 'River Otter SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_river_otter1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_river_otter1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable river otter snap charm, complete with a tail large size! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '209',
    name: 'River Otter SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_river_otter1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_river_otter1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable river otter snap charm, complete with a tail micro size! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  { 
    id: '4', 
    name: 'Black Cat SnapCharm', 
    price: 5, 
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_cat1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Ideal for cat lovers. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '8',
    name: 'White Cat SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_white_cat1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_white_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute white cat snap charm. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '10',
    name: 'Lil Stripe Orange Cat SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_lil_stripe1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_lil_stripe1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable lil\' stripe snap charm, complete with a tail ! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' },
    ]
  },
  {
    id: '11',
    name: 'Brown Cat SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_brown_cat1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_brown_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute brown cat snap charm. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'Black' }
    ]
  },
  {
    id: '104',
    name: 'Black Cat SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_cat1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Ideal for cat lovers large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '108',
    name: 'White Cat SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_white_cat1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_white_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute white cat snap charm large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '110',
    name: 'Lil Stripe Orange Cat SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_lil_stripe1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_lil_stripe1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable lil\' stripe snap charm, complete with a tail large size! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' },
    ]
  },
  {
    id: '111',
    name: 'Brown Cat SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_brown_cat1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_brown_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute brown cat snap charm large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'Black' }
    ]
  },
  {
    id: '204',
    name: 'Black Cat SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_cat1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Ideal for cat lovers micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '208',
    name: 'White Cat SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_white_cat1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_white_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute white cat snap charm micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '210',
    name: 'Lil Stripe Orange Cat SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_lil_stripe1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_lil_stripe1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'This is one adorable lil\' stripe snap charm, complete with a tail micro size! ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '211',
    name: 'Brown Cat SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_brown_cat1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_brown_cat1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'A cute brown cat snap charm micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'Black' }
    ]
  },
  { 
    id: '1', 
    name: 'Alien SnapCharm', 
    price: 5, 
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_alien1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_alien1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Space',
    description: 'Show your alien pride with this unique necklace. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '5',
    name: 'Bunny SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_bunny1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_bunny1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Cute bunny necklace with a fuzzy tail. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '101',
    name: 'Alien SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_alien1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_alien1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Space',
    description: 'Show your alien pride with this unique necklace large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '105',
    name: 'Bunny SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_bunny1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_bunny1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Cute bunny necklace with a fuzzy tail large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '201',
    name: 'Alien SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_alien1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_alien1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Space',
    description: 'Show your alien pride with a very tiny micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '205',
    name: 'Bunny SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_bunny1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_bunny1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'Cute bunny necklace with a fuzzy tail micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '6',
    name: 'Pumpkin SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_pumpkin1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_pumpkin1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A spooky snap charm for Halloween. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '106',
    name: 'Pumpkin SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_pumpkin1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_pumpkin1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A spooky snap charm for Halloween large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '206',
    name: 'Pumpkin SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_pumpkin1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_pumpkin1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A spooky snap charm for Halloween micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  { 
    id: '3', 
    name: 'Dog SnapCharm', 
    price: 5, 
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_dog1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_dog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'For all dog lovers. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '103',
    name: 'Dog SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_dog1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_dog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'For all dog lovers large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '203',
    name: 'Dog SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_dog1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_dog1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Animals',
    description: 'For all dog lovers micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '12',
    name: 'Christmas Tree SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_christmas_tree1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_christmas_tree1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A Christmas tree snap charm for the Holidays. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '13',
    name: 'Christmas Star SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_christmas_star1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_christmas_star1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A Christmas star snap charm for the Holidays. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '7',
    name: 'Snowman SnapCharm',
    price: 5,
    wholesale_price: 3,
    height_inches: 3,
    width_inches: 2,
    depth_inches: 1,
    images: [
      { image_path: standard_snowman1, image_type: ProductImageType.DETAIL },
      { image_path: standard_model_snowman1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A snowman snap charm for winter. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '107',
    name: 'Snowman SnapCharm Large',
    price: 12,
    wholesale_price: 5,
    height_inches: 5.5,
    width_inches: 3.5,
    depth_inches: 1.75,
    images: [
      { image_path: large_snowman1, image_type: ProductImageType.DETAIL },
      { image_path: large_model_snowman1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A snowman snap charm for winter large size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  },
  {
    id: '207',
    name: 'Snowman SnapCharm Micro',
    price: 5,
    wholesale_price: 3,
    height_inches: 2,
    width_inches: 1,
    depth_inches: .5,
    images: [
      { image_path: micro_snowman1, image_type: ProductImageType.DETAIL },
      { image_path: micro_model_snowman1, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.SNAPCHARM,
    category: 'Charms',
    sub_category: 'Seasonal',
    description: 'A snowman snap charm for winter micro size. ' + general_snap_charm_subtext,
    is_customizeable: true,
    enabled: true,
    customization_items: [
      { name: 'BeadColor', max_length: 20, customText: 'White' }
    ]
  }
];
